import React from 'react';
import Image from 'next/image';
import moPartyImage from '../../assets/mo-party-banner.png';
import { Flex } from '@osmosis/react-ui/components/Box';
import { H4 } from '@osmosis/react-ui/components/Text';
import { FormattedMessage } from 'react-intl';

/**
 * NewClinicalBanner.
 */
const NewClinicalBanner = () => {
  return (
    <Flex
      className="justify-center items-center bg-white p-2 pb-0 relative mb-[8px] md:w-[220px] lg:w-[260px]"
      data-testid="new_clinical_banner"
    >
      <Image
        alt="party image of mo"
        src={moPartyImage}
        style={{
          borderRadius: 5,
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
          overflow: 'hidden',
        }}
      />

      <Flex
        flexDirection={'column'}
        alignItems={'start'}
        sx={{
          position: 'absolute',
          left: ['6%', '12px'],
          bottom: ['18%', '8px'],
          width: ['46%', '56%'],
        }}
      >
        <H4
          sx={{
            marginBottom: ['14px', '4px'],
            fontSize: ['20px', '12px', '12px'],
            color: 'primaryText',
            cursor: 'default',
          }}
          data-testid="new_clinical_banner_text"
        >
          <FormattedMessage
            id="newClinicalBanner.explore.text"
            defaultMessage="Explore our newest Clinical Sciences topics!"
          />
        </H4>
      </Flex>
    </Flex>
  );
};

export default NewClinicalBanner;
